import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const getInAppRecallPayload = (campaign: GraphQLCampaign) => {
  const { id: campaignId } = campaign;

  return {
    campaignId,
  };
};
